import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AddCasierComponent } from './add-casier.component';
import { FormsModule } from '@angular/forms';
import { NbCalendarRangeModule } from '@nebular/theme';
import { CustomCalendarModule } from '../../widgets/calendar/calendar.module';
import { UserCardModule } from '../../widgets/dossier_chambres/user-card.module';
import { AddPieceModule } from '../add-piece/add-piece.module';
import { NgxUiLoaderModule } from 'ngx-ui-loader';

@NgModule({
  imports: [CommonModule,
    UserCardModule,
    FormsModule,
    NbCalendarRangeModule,
    CustomCalendarModule,
    AddPieceModule,
    NgxUiLoaderModule

  ],
  declarations: [AddCasierComponent],
  exports: [AddCasierComponent],
})
export class AddCasierModule {}
